import React from "react";
import { Contact } from "./contact";
import { Features } from "./features";
import { Header } from "./header";
import { Services } from "./services";

export const Home = (props) => {
  return (
    <React.Fragment>
      <Header data={props.data.Header} />
      <Services data={props.data.Services} />
      <Features data={props.data.Features} />
      {/* <Gallery data={props.data.Gallery} /> */}
      {/* <Team data={props.data.Team} />
      <Testimonials data={props.data.Testimonials} /> */}
      <Contact data={{contact: props.data.Contact, contactMongolia: props.data.ContactMongolia}} />
    </React.Fragment>
  )
};